import { useState, useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import MessageBox from '../../MessageBox/MessageBox';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import './InfoSegment.css';
import { useNavigate } from 'react-router-dom';

export interface IInfoInput {
  name: string;
  mail: string;
}

interface props {
  data: IInfoInput;
}

const SUBMIT_BUTTON_TITLE = 'DODAJ GWIAZDĘ';

const InfoSegment = (props: props) => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const INFO_URL = '/bands/stars'; 

  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IInfoInput>({
    defaultValues: {
      name: '',
      mail: '',
    },
  });

  useEffect(() => {
    const isAddingStar = sessionStorage.getItem("isAddingStar");
  
    if (isAddingStar === "true") {
      setValue("name", "");
      setValue("mail", "");
    } else{
      setValue("name", props.data.name);
      setValue("mail", props.data.mail);
      sessionStorage.setItem('bandName', props.data.name);
    }
  }, [props.data,setValue]);
  
  const handleBackButtonClick = () => {
    sessionStorage.removeItem('starId');
    sessionStorage.removeItem("isAddingStar"); 
    navigate(-1); 
  };

  const onSubmit: SubmitHandler<IInfoInput> = async (data) => {
    const { name, mail } = data;
    const starId = sessionStorage.getItem('starId');

    try {
        let response;

        if (starId) {
            response = await axiosPrivate.put(
                `/bands/stars/${starId}`,
                JSON.stringify({
                    name: name,
                    email: mail,
                }),
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
        } else {
            response = await axiosPrivate.post(
                INFO_URL,
                JSON.stringify({
                    name: name,
                    email: mail,
                }),
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            sessionStorage.setItem('starId', response.data.id.toString()); 
        }
        setResult(true);
    } catch (error) {
        setResult(false);
    }
    setOpen(true);
};


  return (
    <form className="info-container" onSubmit={handleSubmit(onSubmit)}>
      <h2>Dodaj Gwiazdę</h2>
      <div className="info-content">
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <label>* Nazwa gwiazdy</label>
              <TextField {...field} error={errors.name ? true : false} />
            </div>
          )}
        />
        <Controller
          name="mail"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <label>* E-mail gwiazdy</label>
              <TextField {...field} error={errors.mail ? true : false} />
            </div>
          )}
        />
      </div>
      <Button variant="contained" type="submit" size="large">
        {sessionStorage.getItem("isAddingStar") === "true" ? "DODAJ GWIAZDĘ" : "ZAPISZ GWIAZDĘ"}
      </Button>

      <MessageBox open={open} setOpen={setOpen} error={!result} />
      <Button variant="contained" size='large' onClick={handleBackButtonClick}>Powrót</Button>
    </form>
  );
};

export default InfoSegment;
